/* Kaufschutz: Solange Farbe/Größe nicht aktiv gewählt wurden (Platzhalter
   "Bitte wählen" in den Variant-Dropdowns), ist der In-den-Warenkorb-Button
   deaktiviert. Klick auf den inaktiven Button (landet auf dem Wrapper) zeigt
   einen Hinweis. Funktioniert auf der Produktseite und im Quick-Add-Modal
   (MutationObserver für injizierte Inhalte). */
(function () {
  if (window.__vhVariantGuard) return;
  window.__vhVariantGuard = true;

  function scopeOf(el) {
    return el.closest('dialog') || el.closest('.product-details') || document;
  }

  function emptySelects(scope) {
    return Array.prototype.filter.call(
      scope.querySelectorAll('.variant-option__select'),
      function (s) { return s.value === ''; }
    );
  }

  function setState(btn, missing) {
    if (missing) {
      btn.setAttribute('disabled', '');
      btn.classList.add('vh-guard-disabled');
    } else if (btn.classList.contains('vh-guard-disabled')) {
      btn.removeAttribute('disabled');
      btn.classList.remove('vh-guard-disabled');
    }
  }

  function ensureState(scope) {
    if (!scope) return;
    ensureAll();
  }

  function ensureAll() {
    // Pro Button den eigenen Kontext bewerten (deckt auch Sticky-Bar und Quick-Add-Modal ab)
    document.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      var scope = scopeOf(b);
      setState(b, emptySelects(scope).length > 0);
    });
    document.querySelectorAll('.vh-choose-hint').forEach(function (h) {
      if (!emptySelects(scopeOf(h)).length) h.remove();
    });
  }

  function showHint(scope) {
    var empty = emptySelects(scope);
    empty.forEach(function (s) { s.classList.add('vh-choose-missing'); });
    var picker = scope.querySelector('variant-picker');
    if (picker && !scope.querySelector('.vh-choose-hint')) {
      // Text an die tatsächlich fehlenden Optionen anpassen
      // (Farbe ist seit der Weiß-Vorauswahl praktisch nie leer)
      var onlySize = empty.length > 0 && empty.every(function (s) {
        return /size|größe|groesse/i.test(s.getAttribute('name') || '');
      });
      var p = document.createElement('p');
      p.className = 'vh-choose-hint';
      p.textContent = onlySize ? 'Bitte wähle zuerst eine Größe.' : 'Bitte wähle zuerst Farbe und Größe.';
      picker.insertAdjacentElement('afterend', p);
    }
  }

  // Farbpalette: Klick auf einen Farbkreis setzt das (versteckte) Color-Select
  // und stößt damit die normale Varianten-Logik an (Bildwechsel, Guard, Morph)
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.vh-swatch');
    if (!sw) return;
    var opt = sw.closest('.variant-option');
    var select = opt && opt.querySelector('.variant-option__select');
    if (!select) return;
    opt.querySelectorAll('.vh-swatch').forEach(function (b) {
      b.classList.toggle('is-selected', b === sw);
    });
    select.value = sw.getAttribute('data-vh-swatch-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Klick auf den deaktivierten Button trifft dank pointer-events:none den
  // Wrapper: Hinweis zeigen
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var zone = e.target.closest('.buy-buttons-block, product-form-component, .sticky-add-to-cart, sticky-add-to-cart');
    if (!zone) return;
    var scope = scopeOf(zone);
    if (emptySelects(scope).length) showHint(scope);
  });

  // Sicherheitsnetz: kein Submit, solange nichts gewählt ist (z.B. per Tastatur)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var scope = scopeOf(form);
    if (emptySelects(scope).length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showHint(scope);
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('.variant-option__select')) return;
    if (e.target.value !== '') e.target.classList.remove('vh-choose-missing');
    // Label-Wert mitführen, z.B. "Color: White" / "Size: M"
    var optWrap = e.target.closest('.variant-option');
    var labelValue = optWrap && optWrap.querySelector('label .vh-opt-value');
    if (labelValue) labelValue.textContent = e.target.value ? ': ' + e.target.value : '';
    var scope = scopeOf(e.target);
    ensureState(scope);
    maybeSwapGalleryImage(e.target, scope);
  });

  /* Bei unvollständiger Auswahl (z.B. nur Farbe gewählt) macht die
     Theme-Pipeline nichts, das Produktbild bliebe falsch. Wir holen die Seite
     der zugehörigen Variante und tauschen nur die Galerie aus, exakt so, wie
     es media-gallery.js bei einem vollständigen Variantenwechsel selbst tut. */
  function maybeSwapGalleryImage(select, scope) {
    if (select.value === '') return;
    // Nur die Farbe steuert das Bild. Größe (aus dem Berater gesetzt) darf die
    // Galerie nicht verstellen, sonst springt das Bild bei Größenwahl.
    var oname = (select.getAttribute('name') || '').toLowerCase();
    if (oname.indexOf('color') === -1 && oname.indexOf('farbe') === -1) return;
    if (!emptySelects(scope).length) return; // vollständig: Theme übernimmt
    var opt = select.options[select.selectedIndex];
    var vid = opt && opt.dataset ? opt.dataset.variantId : null;
    if (!vid) return;
    var picker = select.closest('variant-picker');
    var purl = (picker && picker.dataset.productUrl) || (location.pathname.indexOf('/products/') === 0 ? location.pathname : null);
    if (!purl) return;
    // Galerie liegt NEBEN .product-details im Grid, deshalb weiter oben suchen
    var galleryScope = select.closest('dialog') || select.closest('.product-information') || document;
    fetch(purl.split('?')[0] + '?variant=' + vid)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('media-gallery');
        var current = galleryScope.querySelector('media-gallery');
        if (!fresh || !current) return;
        // Bild-ID der Variante mitgeben, damit media-gallery.js beim nächsten
        // Variantenwechsel korrekt vergleichen kann (verhindert ein unnötiges
        // Neuladen beim ersten Größenwechsel nach der Farbwahl)
        try {
          var vjson = JSON.parse(doc.querySelector('variant-picker script[type="application/json"]').textContent);
          if (vjson && vjson.featured_media) fresh.dataset.vhMediaId = String(vjson.featured_media.id);
        } catch (err) { /* Vergleich fällt dann auf den DOM-Fallback zurück */ }
        current.replaceWith(document.importNode(fresh, true));
      })
      .catch(function () {});
  }

  // Quick-Add-Modal injiziert Inhalte nachträglich
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && n.querySelector && (n.querySelector('.variant-option__select') || n.matches('.variant-option__select'))) {
          ensureAll();
          return;
        }
      }
    }
  });

  function init() {
    ensureAll();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
